import QRCode from 'qrcode';

export interface PixConfig {
  pixKey: string;
  holderName: string;
  city: string;
  amount: number;
}

// CRC16-CCITT (polinomio 0x1021) — requerido por el estándar BRCode 2.0.1
const crc16 = (str: string): string => {
  let crc = 0xffff;
  for (let i = 0; i < str.length; i++) {
    crc ^= str.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
    }
  }
  return (crc & 0xffff).toString(16).toUpperCase().padStart(4, '0');
};

// Construye el campo EMV con ID + longitud + valor
const emv = (id: string, value: string): string =>
  `${id}${value.length.toString().padStart(2, '0')}${value}`;

// Genera el payload BRCode 2.0.1 para QR Pix estático
export const buildPixPayload = (config: PixConfig): string => {
  const { pixKey, holderName, city, amount } = config;

  const pixInfo = emv('00', 'br.gov.bcb.pix') + emv('01', pixKey);
  const merchantAccountInfo = emv('26', pixInfo);

  const name = holderName.toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '').slice(0, 25);
  const cityNorm = city.toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '').slice(0, 15);
  const txId = emv('05', '***');
  const additionalData = emv('62', txId);

  const payload =
    emv('00', '01') +                          // Payload Format Indicator
    merchantAccountInfo +                        // Merchant Account Info (Pix)
    emv('52', '0000') +                         // Merchant Category Code
    emv('53', '986') +                          // Currency BRL
    (amount > 0 ? emv('54', amount.toFixed(2)) : '') + // Amount (opcional)
    emv('58', 'BR') +                           // Country Code
    emv('59', name) +                           // Merchant Name
    emv('60', cityNorm) +                       // Merchant City
    additionalData +                             // Additional Data
    '6304';                                      // CRC16 placeholder

  return payload + crc16(payload);
};

// Genera el QR code como data URL (imagen PNG base64)
export const generatePixQR = async (config: PixConfig): Promise<string> => {
  const payload = buildPixPayload(config);
  return QRCode.toDataURL(payload, {
    width: 280,
    margin: 2,
    color: { dark: '#1d2327', light: '#ffffff' },
    errorCorrectionLevel: 'M',
  });
};
